import type { LinkProps } from "next/link";
import NextLink from "next/link";
import type { AnchorHTMLAttributes } from "react";
import { forwardRef } from "react";

import buildUrl from "@/utils/buildUrl";
import { isExternalLink } from "@/utils/slug/isExternalLink";

export type CustomLinkProps = {
  href?: string | null;
  locale?: string;
  customPrefetch?: "onMouseEnter";
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "popover"> &
  Omit<LinkProps, "href">;

const Link = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  ({ href, locale, customPrefetch, ...props }, ref) => {
    if (href) {
      if (href.includes("mailto:")) {
        return (
          <a href={href} target="_blank" rel="noopener noreferrer" {...props} />
        );
      }

      if (href.includes("tel:")) {
        return (
          <a href={href} target="_blank" rel="noopener noreferrer" {...props} />
        );
      }
      if (isExternalLink(href)) {
        return (
          <a href={href} target="_blank" rel="noopener noreferrer" {...props} />
        );
      }
    }

    const url = buildUrl(locale, href?.split("/").filter(Boolean).join("/"));

    return <NextLink ref={ref} href={url} {...props} />;
  },
);

export default Link;
